import React, { FunctionComponent } from 'react';
import { Row as AntdRow } from 'antd';
import { RowProps } from 'antd/lib/grid';

const Row: FunctionComponent<RowProps> = (props) => <AntdRow {...props} />;

export default Row;
